import styled from 'styled-components';

interface IScContainer {
	backgroundColor?: string;
	maxWidth?: string;
}

export const ScContainer = styled.div<IScContainer>`
	padding: 0 20px;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background-color: ${({ theme, backgroundColor }) => backgroundColor ? backgroundColor : theme.colors.transparent};
	@media (min-width: 1220px) {
		padding: 0 50px;
	}
	@media (min-width: 1920px) {
		padding: 0;
		max-width: ${({ theme, maxWidth }) => maxWidth ? maxWidth : '1820px;'};
		margin: 0 auto;
	}
`;
